export default __webpack_public_path__ + "static/real-time-data-updates-ff931bf28802fce82d097becf65c33fb.png";